// src/store/renderControlSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { set } from "react-hook-form"

interface RenderControlState {
  // layerControl: LayerControlState
  togglePanel: {
    reservation: boolean
    waitingList: boolean
    treatment: boolean
    complete: boolean
  }
}

const initialState: RenderControlState = {
  togglePanel: {
    reservation: false,
    waitingList: false,
    treatment: false,
    complete: false,
  },
}

const renderControlSlice = createSlice({
  name: "renderControl",
  initialState,
  reducers: {
    setTogglePanelState(
      state,
      action: PayloadAction<{
        panel: keyof RenderControlState["togglePanel"]
        state: boolean
      }>
    ) {
      state.togglePanel[action.payload.panel] = action.payload.state
    },
  },
})

export const { setTogglePanelState } = renderControlSlice.actions

export default renderControlSlice.reducer
